/**
 * @generated SignedSource<<96d272000a5fc6f59a4e9f19d10a27f7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontMediaSection_viewer$data = {
  readonly muxMonitoringFF: boolean | null;
  readonly vimeoStorefrontVideoHLSPlayerFF: boolean | null;
  readonly " $fragmentType": "StorefrontMediaSection_viewer";
};
export type StorefrontMediaSection_viewer$key = {
  readonly " $data"?: StorefrontMediaSection_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontMediaSection_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontMediaSection_viewer",
  "selections": [
    {
      "alias": "vimeoStorefrontVideoHLSPlayerFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "vimeoStorefrontVideoHLSPlayer"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"vimeoStorefrontVideoHLSPlayer\")"
    },
    {
      "alias": "muxMonitoringFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "muxMonitoring"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"muxMonitoring\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "fa01832d52ab4a6a7f3e42aedc57cda2";

export default node;
